<template>
  <el-dialog
    :visible="true"
    width="400px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      <span>{{ title }}</span>
    </div>
    <div v-loading="loading">
      <el-form
        ref="stockTakingToolForm"
        label-position="top"
        :model="stockTakingTool"
        :rules="rules"
      >
        <el-form-item
          prop="name"
          label="Név"
        >
          <el-input
            v-model="stockTakingTool.name"
          />
        </el-form-item>
      </el-form>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="handleClose"
      >
        Mégse
      </el-button>
      <el-button
        type="primary"
        :loading="buttonLoading"
        @click="store"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>

  export default {

    props: ['type', 'stockTakingToolId'],
    data() {
      return {
        loading: false,
        buttonLoading: false,
        stockTakingTool: {},
        rules: {
          name: [
            {
              required: true,
              message: 'Mező kitöltése kötelező',
              trigger: 'change'
            }
          ],
        },
      };
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új leltár eszköz';
        } else if (this.type === 'update') {
          return 'Leltár eszköz módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadása';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },
    async mounted() {
      this.loading = true;
      if (this.stockTakingToolId) {
        this.stockTakingTool = await this.$store.dispatch('stockTakingTool/fetch', this.stockTakingToolId);
      }
      this.loading = false;
    },
    methods: {
      handleClose() {
        this.$confirm('Biztosan elveted a módosításokat?', {
          confirmButtonText: 'Igen',
          type: 'warning',
        })
        .then(() => {
          this.$router.replace('/processes/stock-takings/stock-taking-tools');
        })
        .catch(() => {
        });
      },


      async store() {
        this.$refs.stockTakingToolForm.validate(async valid => {
          if (valid) {
            this.buttonLoading = true;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('stockTakingTool/create', this.stockTakingTool);
              } else if (this.type === 'update') {
                await this.$store.dispatch('stockTakingTool/update', this.stockTakingTool);
              }
              this.$store.dispatch('stockTakingTool/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/processes/stock-takings/stock-taking-tools');
            } catch (e) {
            }
            this.buttonLoading = false;
          }
        });
      },
    },
  };
</script>
